<template>
  <div id="municipio">
    <div
      v-if="loadingPage || loadingData"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh"
    >
      <b-spinner large variant="primary"></b-spinner>
    </div>

    <div v-else>
      <div class="row mt-3">
        <div class="col-lg-4">
          <vue-select
            name="periodo"
            v-model="periodo"
            class="select-periodo"
            :clearable="false"
            :options="optionsPeriodo"
            label="label"
            placeholder="Período"
            @input="onChangePeriodo"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="col-lg-4">
          <vue-select
            id="select-tipo-equipe"
            name="tipo-equipe"
            v-model="tipoEquipe"
            class="select-tipo-equipe"
            :clearable="true"
            :options="optionsTipoEquipe"
            label="label"
            placeholder="Todas"
            :disabled="disabledSelectTipoEquipe"
            @input="onChangeTipoEquipe"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <dashboard-equipes
        :dadosDashboard="dadosDashboardEquipes"
        :periodo="periodo"
        :tipoEquipe="tipoEquipe"
      ></dashboard-equipes>
    </div>
  </div>
</template>

<script>
import DashboardEquipes from './components/DashboardEquipes'

export default {
  props: {
    loadingPage: {
      type: Boolean,
      default: false,
    },
    cadastros: {
      type: Array,
      default: () => {},
    },
  },
  components: {
    DashboardEquipes,
  },
  data() {
    return {
      dadosDashboardEquipesOriginais: [],
      dadosDashboardEquipes: [],
      periodo: null,
      optionsPeriodo: [],
      loadingData: false,
      optionsTipoEquipe: [
        { label: 'eSF', value: '70' },
        { label: 'eAP', value: '76' },
        { label: 'eSB', value: '71' },
        { label: 'eMulti', value: '72' },
      ],
      tipoEquipe: null,
      disabledSelectTipoEquipe: true,
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
        this.periodo = this.optionsPeriodo[0]
        this.onChangePeriodo(this.periodo)
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    async onChangePeriodo(item) {
      let periodo = item.value.replace('/', '-')
      try {
        this.loadingData = true
        this.disabledSelectTipoEquipe = true
        let response = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}/classificacao-das-equipes/${periodo}`
        )
        if (response) {
          this.dadosDashboardEquipesOriginais = response.data
          this.dadosDashboardEquipes = response.data
          this.onChangeTipoEquipe(this.tipoEquipe)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingData = false
        this.disabledSelectTipoEquipe = false
      }
    },

    onChangeTipoEquipe(tipoEquipe) {
      if (!tipoEquipe) {
        this.dadosDashboardEquipes = this.dadosDashboardEquipesOriginais
        return
      }

      this.dadosDashboardEquipes = this.dadosDashboardEquipesOriginais
        .map((item) => {
          // clonar o item para não alterar o original
          const novoItem = { ...item }

          const equipes = JSON.parse(item.equipes || '[]')

          // filtrar equipes
          const equipesFiltradas = equipes.filter(
            (eq) => eq.tp_equipe == tipoEquipe.value
          )

          // atualizar a chave "equipes" com o resultado filtrado
          novoItem.equipes = JSON.stringify(equipesFiltradas)
          novoItem.qtd_equipes = equipesFiltradas.length

          return novoItem
        })
        // manter apenas itens com equipes após o filtro
        .filter((item) => {
          const eq = JSON.parse(item.equipes)
          return eq.length > 0
        })
    },
  },
}
</script>

<style lang="scss">
#municipio {
}
</style>
